import './home/home-heading/home-heading';

import './slider/slider-medias/slider-medias';